import React, { useState, useEffect, useRef } from 'react';

function toDisplay(val) {
  if (val === '' || val === null || val === undefined) return '';
  const str = String(val);
  const parts = str.split('.');
  const intFormatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return parts[1] !== undefined ? `${intFormatted},${parts[1]}` : intFormatted;
}

function process(raw) {
  // Strip all thousands-separator dots, then parse
  const clean = raw.replace(/\./g, '');
  const commaIdx = clean.indexOf(',');
  if (commaIdx !== -1) {
    const intPart = clean.substring(0, commaIdx).replace(/\D/g, '');
    const decPart = clean.substring(commaIdx + 1).replace(/\D/g, '').substring(0, 2);
    const formatted = intPart ? intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.') : '';
    return { display: `${formatted},${decPart}`, numStr: `${intPart || '0'}.${decPart}` };
  } else {
    const intPart = clean.replace(/\D/g, '');
    const formatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return { display: formatted, numStr: intPart };
  }
}

export default function MoneyInput({ value, onChange, className = 'form-input', placeholder = '0', style, autoFocus }) {
  const [display, setDisplay] = useState(() => toDisplay(value));
  const skipSync = useRef(false);

  useEffect(() => {
    if (skipSync.current) { skipSync.current = false; return; }
    setDisplay(toDisplay(value));
  }, [value]);

  function handleChange(e) {
    const { display: newDisplay, numStr } = process(e.target.value);
    setDisplay(newDisplay);
    skipSync.current = true;
    onChange(numStr);
  }

  function handleKeyDown(e) {
    if (e.key === '.' || e.key === 'Decimal') {
      e.preventDefault();
      if (!display.includes(',')) {
        const input = e.target;
        const pos = input.selectionStart;
        const newRaw = display.substring(0, pos) + ',' + display.substring(input.selectionEnd);
        const { display: newDisplay, numStr } = process(newRaw);
        setDisplay(newDisplay);
        skipSync.current = true;
        onChange(numStr);
        requestAnimationFrame(() => {
          const newPos = newDisplay.indexOf(',') + 1;
          input.setSelectionRange(newPos, newPos);
        });
      }
    }
  }

  return (
    <input
      className={className}
      style={style}
      type="text"
      inputMode="decimal"
      value={display}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      autoFocus={autoFocus}
    />
  );
}
